import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { AreasGrid } from "@/components/AreasGrid";

export default function Areas() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      <button data-testid="areas-volver" onClick={() => navigate("/")} className="inline-flex items-center gap-1.5 text-[#3A6B56] font-semibold text-base min-h-[44px]">
        <ChevronRight size={22} className="rotate-180" /> Inicio
      </button>
      <header className="aldia-fade-up">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-[#1C2421]">Mis áreas</h1>
        <p className="text-base text-[#6E7A74] mt-1">Aquí tienes organizada toda tu información. Elige una sección para verla.</p>
      </header>

      <AreasGrid testidPrefix="areas-page" />
    </div>
  );
}
